import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { DebitFormDataService } from 'src/app/services/debit-form-data.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { UploaddataService } from 'src/app/services/uploaddata.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-change-of-bank-details',
  templateUrl: './change-of-bank-details.component.html',
  styleUrls: ['./change-of-bank-details.component.scss']
})
export class ChangeOfBankDetailsComponent implements OnInit {
  data: any = [];
  dataSource: any = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
  "CustomerNumber",
  "TimeStamp",
  "DocumentProof"

  ];
  isRestrictedDate=false;
  constructor(
    private debitform:DebitFormDataService,
    private uploaddataservice:UploaddataService,
    private navigation:NavigationService,
  ) { }
@ViewChild(MatPaginator,{static:true})paginator:MatPaginator
  ngOnInit(): void {
    this.gettabledate()
  }
  gettabledate(){
    this.debitform.getBankingDetailsProof().subscribe((result)=>{
      this.data=result;
      this.dataSource=new MatTableDataSource(this.data)
      this.dataSource.paginator=this.paginator;
  })
}
  Refresh(){
    this.gettabledate()

  }
  update(){
    if(this.isRestrictedDate){
      Swal.fire('Not Allowed','Today not permission to update','warning')
    }
    else
      this.navigation.gotoaddBankingDetails();

  }
  download(id){
    this.uploaddataservice.downloadBankingDetailsProof(id).subscribe((data)=>{
      if (data != null) {
        const link = document.createElement("a");
        link.href = data.baseUrl + data.byteImage;
        link.download = `${data.filename}`; 
        link.click();
    }
    })

  }

  resticteddate(){
      const date: Date = new Date();
      let lastDay: Date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      lastDay = moment(lastDay).toDate(); // Convert back to Date object if needed

      const lastDayFormatted: string = moment(lastDay).format("DD");

      const days: string[] = ["01", "14", "15"];
      days.push(lastDayFormatted);

      const nowDate: string = moment(date).format("DD");

      this.isRestrictedDate = days.indexOf(nowDate) !== -1;
  }
}
